var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCodescanCheckmarkGradient = function SvgCodescanCheckmarkGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#codescanCheckmarkGradient_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#codescanCheckmarkGradient_svg__b)",
    d: "M15.42 9.42a1.125 1.125 0 0 0-1.59-1.59l-4.455 4.454-1.455-1.455a1.125 1.125 0 0 0-1.59 1.592l2.25 2.25c.439.439 1.151.439 1.59 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#codescanCheckmarkGradient_svg__c)",
    fillRule: "evenodd",
    d: "M11.25 22.5c2.701 0 5.18-.952 7.12-2.54l3.71 3.71a1.125 1.125 0 0 0 1.59-1.59l-3.71-3.71a11.2 11.2 0 0 0 2.54-7.12C22.5 5.037 17.463 0 11.25 0S0 5.037 0 11.25 5.037 22.5 11.25 22.5m0-20.25a9 9 0 1 0 6.14 15.58 1.13 1.13 0 0 1 .44-.44 9 9 0 0 0-6.58-15.14",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "codescanCheckmarkGradient_svg__b",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#389CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B00DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "codescanCheckmarkGradient_svg__c",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#389CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B00DE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "codescanCheckmarkGradient_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCodescanCheckmarkGradient;